import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be87480"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stub" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "icon-mic-off" }
const _hoisted_4 = {
  key: 0,
  class: "call-wrap"
}
const _hoisted_5 = {
  key: 2,
  class: "call-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DraggableBlock = _resolveComponent("DraggableBlock")!
  const _component_UserWithoutVideo = _resolveComponent("UserWithoutVideo")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_VideoCallFooter = _resolveComponent("VideoCallFooter")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-call", {'video-call-minimize': _ctx.settings.minimize, 'video-call-maximize': _ctx.settings.maximize}])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["wrap", {'black-background': _ctx.settings.fullscreen }]),
      id: "video-container"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["video-container", _ctx.videoContainerClasses])
      }, [
        _withDirectives(_createVNode(_component_DraggableBlock, {
          ref: "draggable",
          isRemoteVideoMute: _ctx.isRemoteVideoMute
        }, null, 8, ["isRemoteVideoMute"]), [
          [_vShow, !_ctx.isLocalVideoMute && !_ctx.settings.maximize]
        ]),
        (_ctx.isTeleportVideo)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: ".draggable-video",
              disabled: _ctx.needTeleport
            }, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["outgoing-video", _ctx.outgoingVideoClasses]),
                id: "local-video"
              }, _hoisted_2, 2), [
                [_vShow, !_ctx.isLocalVideoMute]
              ])
            ], 8, ["disabled"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_UserWithoutVideo, {
          class: _normalizeClass(_ctx.outgoingBlockClasses),
          isWindow: _ctx.isWindowBlock,
          "show-loading": !_ctx.isCallConnected
        }, null, 8, ["class", "isWindow", "show-loading"]), [
          [_vShow, _ctx.isLocalVideoMute]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["incoming-video", _ctx.incomingVideoClasses]),
          id: "remote-video"
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Icon, {
              class: "icon-mute",
              color: "--sui-white",
              name: "ic24-mic-off",
              width: "20",
              height: "20"
            })
          ], 512), [
            [_vShow, _ctx.isRemoteMute]
          ])
        ], 2), [
          [_vShow, !_ctx.isRemoteVideoMute]
        ]),
        _withDirectives(_createVNode(_component_UserWithoutVideo, {
          class: _normalizeClass(_ctx.incomingBlockClasses),
          isWindow: !_ctx.isWindowBlock,
          "show-loading": !_ctx.isCallConnected
        }, null, 8, ["class", "isWindow", "show-loading"]), [
          [_vShow, _ctx.isRemoteVideoMute]
        ])
      ], 2),
      _createVNode(_component_VideoCallFooter, {
        isMaximize: _ctx.settings.maximize
      }, null, 8, ["isMaximize"])
    ], 2), [
      [_vShow, !_ctx.settings.minimize]
    ]),
    (_ctx.settings.minimize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Typography, { class: "phone-number" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.selectCall?.number), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.minimize && _ctx.callDuration[_ctx.selectCall?.id] && _ctx.selectCall?.status === 'CONNECTED')
      ? (_openBlock(), _createBlock(_component_Typography, {
          key: 1,
          class: "call-time"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.selectCall.active ? _ctx.timeFormat(_ctx.callDuration[_ctx.selectCall?.id].callDuration) : _ctx.timeFormat(_ctx.callDuration[_ctx.selectCall?.id].pauseDuration)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.settings.minimize)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.selectCall?.status !== 'CONNECTED')
            ? (_openBlock(), _createBlock(_component_Loading, {
                key: 0,
                class: "animation"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "call-button button-end",
            mode: "alert",
            iconOnly: "",
            icon: {name: 'ic20-phone-missed', color: '--sui-white'},
            onClick: _cache[0] || (_cache[0] = () => _ctx.hangUp({ id: _ctx.selectCall.id }))
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}